import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';


@Component({
  selector: 'app-activation-account',
  templateUrl: './activation-account.component.html',
  styleUrls: ['./activation-account.component.scss']
})
export class ActivateAccountComponent implements OnInit {
  showMessage:boolean = false;
  slideData = [
    {
        "title": "Inclusive Market",
        "subTitle": "Toutes vos assurances en 1 seul endroit",
        "description": "Votre devis gratuit personnalisé en quelques clics",
        "img": "assets/images/slide-automobile.jpg",
        "type": "Votre compte a été activée avec succés",
        "imgIcon": "assets/images/valid.png",
        "imgIconError": "assets/images/error-activation.png"
    }
  ]
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private accountService:AccountService ) { }

  ngOnInit(): void {
     this.activateAccount()
  }
  activateAccount(){
    this.activatedRoute.queryParams.subscribe(param => {
      this.accountService.activate(param.id).subscribe((resp) => {
        if (resp['responseCode'] == 200) {
        this.showMessage = true
        } else if (resp['code'] == 400) {
            console.error(resp['message']);
            this.router.navigate(['/']);
        }
    }, error => {
        console.error('error');
    });
    });
    

  }

}
